import * as cn from "./Entrance.scss"

import * as React from "react"

import {User} from "./../model/User"
import {SummaryRow, entranceColumns} from "./Final"
import {DemandList, DemandByYear, Demand} from "../model/Demand";
import {getCompany, getSpeciality, getUniversityBranch} from "../model/utils/utils";
import {Divisions} from "../model/Division";
import {Specialities, Speciality} from "../model/Speciality";
import {UniversityBranches, UniversityBranch} from "../model/UniversityBranch";

type Props = {
    demand: DemandList
    divisions: Divisions
    specialities: Specialities
    universityBranches: UniversityBranches
    user: User
    company: string
    total: SummaryRow
    totalNuclear: SummaryRow
    totalNationalProject: SummaryRow
    order: number
}

type RowProps = {
    demandByYear: DemandByYear
    speciality: Speciality
    universityBranch: UniversityBranch
    company: {
        company: string
    }
    shift: number
}

const Row = ({
    demandByYear,
    speciality: {
        title: speciality,
        category,
        code,
    },
    universityBranch: {
        title: university,
    },
    company: {
        company,
    },
    shift,
}: RowProps) => (
    <tr className = {cn.row}>
        <td className = {cn.cell}>{company}</td>
        <td className = {cn.cell}>{category}</td>
        <td className = {cn.cell}>{code + " — " + speciality}</td>
        {entranceColumns.map(year => <td {...{key: year}} className = {cn.cell}>{demandByYear[year + shift] || ""}</td>)}
        <td className = {cn.cell}>{university}</td>
    </tr>
)

export const Entrance: React.FC<Props> = ({demand, company, user, divisions, specialities, universityBranches, total, totalNuclear, totalNationalProject, order}) => (
    <div className = {cn.component}>
        <div className = {cn.page}>
            <br/>
            <div className = {cn.heading}>
                <div className = {cn.title}>
                    Заявка на формирование Контрольных цифр приема
                    <br/>
                    для Государственной корпорации «Росатом»
                    <br/>
                    Приложение № {order}
                </div>
                <div className = {cn.meta}>
                    <div className = {cn.label}>Организация:</div><div className = {cn.value}>{company}</div>
                </div>
                <div className = {cn.meta}>
                    <div className = {cn.label}>Дата заполнения:</div>
                    <div className = {cn.value}>
                        {("0" + new Date().getDate()).slice(-2) + "." + ("0"+(new Date().getMonth()+1)).slice(-2) + "." + new Date().getFullYear()}
                    </div>
                </div>
{/*
                <div className = {cn.meta}>
                    <div className = {cn.label}>Ответственный:</div><div className = {cn.value}>{user.executor.fullName}</div>
                </div>
*/}
            </div>
            <br/>
            <br/>
            <table className = {cn.table} cellPadding = {0} cellSpacing = {0}>
                <colgroup>
                    {Array.apply(null, Array(entranceColumns.length + 4)).map((value, key) => <col {...{key}} className = {cn.column}/>)}
                </colgroup>
                <thead className = {cn.head}>
                    <tr className = {cn.headRow}>
                        <td className = {cn.headCell} rowSpan = {3}>Предприятие</td>
                        <td className = {cn.headCell} rowSpan = {3}>УО</td>
                        <td className = {cn.headCell} rowSpan = {3}>Направление подготовки/Специальность</td>
                        <td className = {cn.headCell} rowSpan = {2} colSpan = {entranceColumns.length}/>
                        <td className = {cn.headCell} rowSpan = {3}>Образовательная организация</td>
                    </tr>
                    <tr className = {cn.headRow}/>
                    <tr className = {cn.headRow}>
                        {entranceColumns.map(year => <td className = {cn.headCell} key = {year}>{year - 2000}</td>)}
                    </tr>
                </thead>
                <tbody>
                    {demand.map((demand: Demand) => {
                        if (!demand.entranceTotal(entranceColumns)) {
                            return null
                        }

                        const speciality = getSpeciality(specialities, demand.specialityId)

                        const row = (
                            <Row {...{
                                shift: 0,
                                key: demand.id,
                                demandByYear: demand.entranceByYear,
                                company: getCompany(divisions, demand.companyId),
                                speciality,
                                universityBranch: getUniversityBranch(universityBranches, demand.universityBranchId),
                            }}/>
                        )

                        if (speciality.master && speciality.bachelorSpecialityId && demand.addBachelorDemand && demand.entranceTotal(entranceColumns, 4)) {
                            return [
                                row,
                                <Row {...{
                                    shift: 4,
                                    key: demand.id * 10,
                                    demandByYear: demand.entranceByYear,
                                    company: getCompany(divisions, demand.companyId),
                                    speciality: getSpeciality(specialities, speciality.bachelorSpecialityId),
                                    universityBranch: getUniversityBranch(universityBranches, demand.universityBranchId),
                                }}/>,
                            ]
                        } else {
                            return row
                        }

                    }).toList()}
                    <tr className = {cn.rowTotal}>
                        <td className = {cn.cell}>Итого:</td>
                        <td className = {cn.cell}/>
                        <td className = {cn.cell}/>
                        {entranceColumns.map(year => <td {...{key: year}} className = {cn.cell}>{total[year] || ""}</td>)}
                        <td className = {cn.cell}/>
                    </tr>
                    <tr className = {cn.rowTotal}>
                        <td className = {cn.cell}>в т.ч. по ядерным специальностям:</td>
                        <td className = {cn.cell}/>
                        <td className = {cn.cell}/>
                        {entranceColumns.map(year => <td {...{key: year}} className = {cn.cell}>{totalNuclear[year] || ""}</td>)}
                        <td className = {cn.cell}/>
                    </tr>
                    <tr className = {cn.rowTotal}>
                        <td className = {cn.cell}>в т.ч. потребности в рамках нац. проекта "Новые атомные и энергетические технологии":</td>
                        <td className = {cn.cell}/>
                        <td className = {cn.cell}/>
                        {entranceColumns.map(year => <td {...{key: year}} className = {cn.cell}>{totalNationalProject[year] || ""}</td>)}
                        <td className = {cn.cell}/>
                    </tr>
                </tbody>
            </table>
        </div>
        <div className = {cn.page}>
            <table className = {cn.table} cellPadding = {0} cellSpacing = {0}>
                <colgroup>
                    {Array.apply(null, Array(entranceColumns.length + 4)).map((value, key) => <col {...{key}} className = {cn.column}/>)}
                </colgroup>
                <tfoot>
                    <tr className = {cn.footRow}/>

                    {[
                        <tr key = {0} className = {cn.footRow}>
                            <td className = {cn.footCell} colSpan = {3} rowSpan = {3} style={{verticalAlign: 'bottom'}}>{user.chief.position}</td>
                            <td className = {cn.footCell}/>
                            <td className = {cn.footCell} colSpan = {entranceColumns.length} rowSpan = {3}>{user.chief.fullName}</td>
                        </tr>,
                        <tr key = {1} className = {cn.footRow}/>,
                        <tr key = {2} className = {cn.footRow}/>,
                        <tr key = {3} className = {cn.footRow}/>,
                        <tr key = {4} className = {cn.footRow}>
                            <td className = {cn.footCell} colSpan = {4}/>
                            <td colSpan = {entranceColumns.length} className = {cn.sign}>(Подпись)</td>
                        </tr>,
                        <tr key = {5} className = {cn.footRow}/>,
                    ]}

                    <tr className = {cn.footRow}>
                        <td className = {cn.footCell} colSpan = {3} rowSpan = {3} style={{verticalAlign: 'bottom'}}>{user.executor.position}</td>
                        <td className = {cn.footCell}/>
                        <td className = {cn.footCell} colSpan = {entranceColumns.length} rowSpan = {3}>{user.executor.fullName}</td>
                    </tr>
                    <tr className = {cn.footRow}/>
                    <tr className = {cn.footRow}/>
                    <tr className = {cn.footRow}/>
                    <tr key = {4} className = {cn.footRow}>
                        <td className = {cn.footCell} colSpan = {4}/>
                        <td colSpan = {entranceColumns.length} className = {cn.sign}>(Подпись)</td>
                    </tr>
{/*
                    <tr className = {cn.footRow}>
                        <td className = {cn.executor}>Ответственный:</td>
                        <td className = {cn.footCell} colSpan = {entranceColumns.length + 3}>{user.executor.fullName}</td>
                    </tr>
*/}
                    <tr className = {cn.footRow}>
                        <td/>
                        <td className = {cn.footCell} colSpan = {entranceColumns.length + 3}>{(user.executor.contacts !== undefined) ? user.executor.contacts.first() : ""}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
)